import en from './en.json';
import uk from './uk.json';
import pl from './pl.json';
import ru from './ru.json';
import es from './es.json';
import uz from './uz.json';
import hi from './hi.json';
import { createLocale } from '../../utils.js';

const locales = {
  en: createLocale(en, 'products'),
  uk: createLocale(uk, 'products'),
  pl: createLocale(pl, 'products'),
  ru: createLocale(ru, 'products'),
  es: createLocale(es, 'products'),
  uz: createLocale(uz, 'products'),
  hi: createLocale(hi, 'products'),
};

export default locales;
